import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { IState } from '../reducers';

export const useTypedSelector: TypedUseSelectorHook<IState> = useSelector;
